import React from 'react';

const CTASection = ({ onJoinExperience }) => {
  return (
    <div className="bg-black py-20 px-6 border-t border-white/10" data-testid="cta-section">
      <div className="max-w-3xl mx-auto text-center">
        {/* Urgency Banner */}
        <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-4 py-2 mb-8">
          <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
          <span className="text-red-400 text-xs tracking-wider font-medium">PLUS QUE 4 PLACES DISPONIBLES</span>
        </div>

        <p className="text-[#D4A574] text-[10px] tracking-[0.4em] mb-4">SECRET CAMP • ESSAOUIRA</p>
        <h2 className="font-italiana text-4xl md:text-5xl text-white mb-6 tracking-[0.08em] uppercase">
          Dans 6 jours,<br/><span className="text-[#D4A574]">tu ne seras plus le même</span>
        </h2>
        
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8 text-white/60 text-sm tracking-wider">
          <span>6 nuits</span>
          <span className="text-[#D4A574]">•</span>
          <span>All-inclusive</span>
          <span className="text-[#D4A574]">•</span>
          <span>10-12 hommes</span>
        </div>
        
        <p className="text-[#D4A574] text-4xl md:text-5xl font-italiana mb-4">6 500€</p>
        <p className="text-white/40 text-xs tracking-wider mb-10">TOUT INCLUS • HORS VOLS</p>
        
        <button
          onClick={onJoinExperience}
          data-testid="cta-join-btn"
          className="bg-[#D4A574] hover:bg-[#C39563] text-white px-12 py-5 rounded-full text-sm tracking-[0.2em] font-medium transition-all hover:scale-105 uppercase shadow-lg shadow-[#D4A574]/20"
        >
          Réserver ma place
        </button>
        
        <p className="text-white/30 text-xs mt-8 tracking-wider">Sélection sur dossier • Places limitées</p>
      </div>
    </div>
  );
};

export default CTASection;
